module.exports = __webpack_public_path__ + "img/skinner-2-l.699e0f42.png";